export default __webpack_public_path__ + "static/media/homeIcon.f73471f9.svg";